<div class="table-container activeCaseCnt">
    <table class="table" [attr.aria-rowcount]="datalist.length">
        <thead>
            <tr>
                <th *ngFor="let col of fieldsConfig.Columns;let colIdx=index;">
                    {{col.HeaderTxt}}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let case of datalist | caseStatusFilter: searchText ;let rowIdx=index;" role="row"
                [attr.aria-rowindex]="rowIdx">
                <ng-container *ngFor="let col of fieldsConfig.Columns;let colIdx=index;">
                    <ng-container [ngTemplateOutlet]="getTemplate(col.Template)"
                        [ngTemplateOutletContext]="{ $implicit: case, index: rowIdx,colIdx:colIdx, col: col}">
                    </ng-container>
                </ng-container>
            </tr>
            <tr *ngIf="datalist.length === 0">
                {{'LblNoDataFound' | translate}}
            </tr>
        </tbody>
    </table>
</div>
<ng-template #baseTemplate let-dataItem let-col="col" let-rowIndex='index' let-colIndex='colIdx'>
    <td class="base-template" role="gridcell" [attr.data-cell-index]="getCellIndex(rowIndex,colIndex)"
        [attr.tabIndex]="getCellIndex(rowIndex,colIndex) === navigationIndex ? 0 :-1" [attr.aria-colindex]='colIndex'
        [title]='dataItem | nestedData : col.Field'>
        {{dataItem | nestedData : col.Field}}
    </td>
</ng-template>
<ng-template #ageTemplate let-dataItem let-col="col" let-rowIndex='index' let-colIndex='colIdx'>
    <td class="base-template" role="gridcell" [attr.data-cell-index]="getCellIndex(rowIndex,colIndex)"
        [attr.tabIndex]="getCellIndex(rowIndex,colIndex) === navigationIndex ? 0 :-1" [attr.aria-colindex]='colIndex'
        [title]='dataItem | nestedData : col.Field'>
        {{ getAgeFromBirthDate(dataItem | nestedData : col.Field) }}
    </td>
</ng-template>
<ng-template #nameTemplate let-dataItem let-col="col" let-rowIndex='index' let-colIndex='colIdx'>
    <td class="base-template" role="gridcell" [attr.data-cell-index]="getCellIndex(rowIndex,colIndex)"
        [attr.tabIndex]="getCellIndex(rowIndex,colIndex) === navigationIndex ? 0 :-1" [attr.aria-colindex]='colIndex'
        [title]='dataItem | nestedData : col.Field'>
        {{dataItem | nestedData : col.Field}} {{dataItem | nestedData : col.SubField}}
        <div style="display: none;">
            (Id: {{ dataItem | nestedData : 'CaseId' }})
        </div>
    </td>
</ng-template>
<ng-template #selectConsultant let-dataItem let-col="col" let-rowIndex='index' let-colIndex='colIdx'>
    <td *ngxPermissionsOnly="['superadmin', 'admin']" class="base-template" role="gridcell"
        [attr.data-cell-index]="getCellIndex(rowIndex,colIndex)"
        [attr.tabIndex]="getCellIndex(rowIndex,colIndex) === navigationIndex ? 0 :-1" [attr.aria-colindex]='colIndex'
        [title]='dataItem | nestedData : col.Field'>
        <p-checkbox name="consultants_{{rowIndex}}" [disabled]="disabledConsultant(dataItem.Id)" [value]="dataItem.Id"
            [(ngModel)]="selectedConsultants" (onChange)="checkConsultant(col.selected, $event, dataItem);"
            [disabled]="dataItem.IsRejected">
        </p-checkbox>
    </td>
</ng-template>
<ng-template #selectClinician let-dataItem let-col="col" let-rowIndex='index' let-colIndex='colIdx'>
    <td *ngxPermissionsOnly="['patient']" class="base-template" role="gridcell"
        [attr.data-cell-index]="getCellIndex(rowIndex,colIndex)"
        [attr.tabIndex]="getCellIndex(rowIndex,colIndex) === navigationIndex ? 0 :-1" [attr.aria-colindex]='colIndex'>
        <p-checkbox name="clinician" [value]="dataItem.Id" [(ngModel)]="selectedClinician"
            (onChange)="checkClinician(col.selected, $event, dataItem);">
        </p-checkbox>
    </td>
</ng-template>
<ng-template #isPrimaryConsultant let-dataItem let-col="col" let-rowIndex='index' let-colIndex='colIdx'>
    <td *ngxPermissionsOnly="['superadmin', 'admin']" class="base-template" role="gridcell"
        [attr.data-cell-index]="getCellIndex(rowIndex,colIndex)"
        [attr.tabIndex]="getCellIndex(rowIndex,colIndex) === navigationIndex ? 0 :-1" [attr.aria-colindex]='colIndex'
        [title]='dataItem | nestedData : col.Field'>
        <p-checkbox name="clinician" [value]="dataItem.Id" [(ngModel)]="selectedPrimaryConsultant"
            (onChange)="primaryConsultant(col.selected, $event, dataItem);">
        </p-checkbox>
    </td>
</ng-template>
<ng-template #superAdminActionBtns let-dataItem let-col="col" let-rowIndex='index' let-colIndex='colIdx'>
    <td *ngxPermissionsOnly="['superadmin', 'clinician','admin']" class="base-template" role="gridcell"
        [attr.data-cell-index]="getCellIndex(rowIndex,colIndex)"
        [attr.tabIndex]="getCellIndex(rowIndex,colIndex) === navigationIndex ? 0 :-1" [attr.aria-colindex]='colIndex'
        [title]='dataItem | nestedData : col.Field'>
        <i class="far fa-edit fontawesomeCls" *ngIf="col.editUser" (click)="editUser(col.editUser, dataItem)"
            [pTooltip]=" 'LblEdit'|translate " tooltipPosition='bottom'></i>
        <i class="far fa-trash-alt fontawesomeCls" *ngIf="col.deleteUser" (click)="deleteUser(col.deleteUser, dataItem)"
            [pTooltip]=" 'LblDelete'|translate " tooltipPosition='bottom'></i>
        <button class="section-header button transparent-button"
            (click)="approveUser(col.approveUser, dataItem)" *ngIf="col.approveUser && !isApprovedByApprover(dataItem)">{{'LblApprove'|translate}}</button>
        <button class="section-header button transparent-button"
            (click)="approveUser(col.approveUser, dataItem)" [disabled]="true" *ngIf="col.approveUser && isApprovedByApprover(dataItem)">{{'LblApproved'|translate}}</button>
<!--
        <i class="fas fa-check-circle fontawesomeCls" *ngIf="col.approveUser && !isApprovedByApprover(dataItem)"
            (click)="approveUser(col.approveUser, dataItem)" [pTooltip]=" 'LblApprove'|translate "
            tooltipPosition='bottom'></i>
-->    </td>
</ng-template>